<script setup>
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { declension } from "@/utils/functions";
import { sendMetrik } from '@/utils/metrika';
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";

const props = defineProps({
    link: {
        type: Boolean,
        default: false
    },
    linkUrl: {
        type: String,
        default: ''
    },
    time : {
        type: String,
        default: '00:00:00'
    },
    goal: {
        type: String,
        default: ''
    }   
})

const timeAr = computed(() => props.time.split(':'));

</script>
<template>
    <div class="session-timer">
        <div class="session-timer__title">
            <slot></slot> 
        </div>         
        <div class="session-timer__row-time">
            <div class="session-timer__time">
                <span>{{timeAr[0] }}</span>
                <span>{{ declension(timeAr[0], ['час', 'часа', 'часов']) }}</span>
            </div>
            <div class="session-timer__time">
                <span>{{ timeAr[1] }}</span>
                <span>{{ declension(timeAr[1], ['минута', 'минуты', 'минут']) }}</span>
            </div>
            <div class="session-timer__time">
                <span>{{ timeAr[2] }}</span>
                <span>{{ declension(timeAr[2], ['секунда', 'секунды', 'секунд']) }}</span>
            </div>
        </div>
        <RouterLink v-if="props.link" @click="sendMetrik('reachGoal', props.goal)" :to="props.linkUrl" class="session-timer__btn btn">Играть</RouterLink>
        <BaseButtonUploadReceipt :type-btn="props.goal" v-else class="session-timer__btn btn" >Загрузить чек</BaseButtonUploadReceipt>
    </div>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
.session-timer {
    display: flex;
    flex-direction: column;
    background: var(--fill-accent-1-1);
    border: 1px solid var(--border-accent-2-4);
    border-radius: 1.6rem;
    padding-top: 1rem;
    &__title {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .5rem;
        font-weight: 400;
        font-size: 1.4rem;
        line-height: 140%;
    }

    &__row-time {
        display: grid;
        grid-template-columns: repeat(3, 1fr );
        margin-bottom: 1rem;
    }

    &__time {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span {
            font-family: var(--second-family);
            font-weight: 700;
            font-size: 2rem;
            line-height: 110%;
            text-transform: uppercase;
            text-align: center;
            color: var(--text-accent-2-100);
            &:last-child {
                font-family: var(--font-family);
                font-weight: 400;
                font-size: 1.2rem;
                line-height: 140%;
                text-transform: lowercase;
                text-align: center;
                color: var(--text-inverse-100);
            }
        }
    }

    &__btn {
        width: 100%;
        min-height: 4.8rem;
        font-size: 2rem;
        border-radius: 1.6rem;
    }
}
:deep(.session-timer__fire) {
    
}
:deep(.session-timer__number) {
    font-size: 2rem;
    
}
:deep(.game-banner__timer-text.--warning) {
    color: var(--text-accent-2-100);
    font-size: 1.6rem;
    padding: 0 24px 10px;
    
}
:deep(.session-timer__leaf) {
    width: 2.4rem;
    height: 2.4rem;
}

</style>